<template>
  <TextInput
    ref="inputComponent"
    :value="value"
    :forceValidate="forceValidate"
    :error="error"
    v-on="listeners"
    v-bind="bindings"
  ></TextInput>
</template>

<script>
  import intlTelInput from 'intl-tel-input';

  export default {
    inheritAttrs: false,

    props: {
      value: true,

      forceValidate: {
        type: Boolean,
        default: false
      },

      error: {
        type: [String],
        default: ''
      }
    },

    computed: {
      listeners () {
        return {
          ...this.$listeners,
          input: () => this.emitInput()
        };
      },

      bindings () {
        return {
          ...this.$attrs
        }
      }
    },

    created() {
      this.emitInput = this.emitInput.bind(this);
    },

    mounted() {
      this.iti = intlTelInput(this.$refs.inputComponent.$refs.input, {
        formatOnInit: false,
        separateDialCode: false,
        initialCountry: 'ru',
        autoHideDialCode: false,
        nationalMode: false,
        preferredCountries: ['ru', 'ua', 'by', 'kz', 'ee', 'us', 'md', 'lv', 'cz'],
        customPlaceholder: () => this.$attrs.placeholder
      });

      this.$refs.inputComponent.$refs.input.addEventListener('countrychange', this.emitInput);
    },

    beforeDestroy() {
      this.$refs.inputComponent.$refs.input.removeEventListener('countrychange', this.emitInput);
      this.iti.destroy();
    },

    methods: {
      emitInput () {
        this.$emit('input', this.iti.getNumber());
      }
    }
  }
</script>